<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>
        <v-list-item to="/">
          <v-list-item-action>
            <v-icon>fa-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Articles</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/tags">
          <v-list-item-action>
            <v-icon>fa-tags</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Tags</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/stats">
          <v-list-item-action>
            <v-icon>fa-chart-area</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Stats</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item to="/social">
          <v-list-item-action>
            <v-icon>fa-hashtag</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Social</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout">
          <v-list-item-action>
            <v-icon>fa-sign-out-alt</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Logout</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Reporter Cuminaivel</v-toolbar-title>
      <v-layout align-baseline class="fab-container">
        <v-btn
          @click="alertBannerDialog=true"
          dark
          fab
          small
          color="red"
          v-if="$route.name==='Home'"
          class="mr-4"
        >
          <v-icon>fa-exclamation</v-icon>
        </v-btn>
        <v-btn @click="newArticleDialog=true" dark fab color="green" v-if="$route.name==='Home'">
          <v-icon>fa-plus</v-icon>
        </v-btn>
      </v-layout>
      
    </v-app-bar>

    <v-content>
      <v-container grid-list-md fluid>
        <router-view />
      </v-container>
    </v-content>

    <v-footer app>
      <span>&copy; TSoftware 2019</span>
    </v-footer>

    <v-dialog v-model="newArticleDialog" width="500">
      <v-card>
        <v-tabs v-model="tab" background-color="transparent" grow>
          <v-tab v-for="item in tabtitles" :key="item">{{ item }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-card-title class="headline" primary-title>New article</v-card-title>
            <v-card-text>
              <v-text-field label="Title" v-model="newArticleTitle" required></v-text-field>
            </v-card-text>
          </v-tab-item>
          <v-tab-item>
            <v-card-title class="headline" primary-title>New from URL</v-card-title>
            <v-card-text>
              <v-text-field label="URL" v-model="newArticleURL"></v-text-field>
            </v-card-text>
          </v-tab-item>
        </v-tabs-items>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="newArticleDialog=false; newArticleTitle=''">Cancel</v-btn>
          <v-btn
            :loading="loading"
            color="success"
            text
            @click="newArticle"
            :disabled="formStatus"
          >Create</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog for alert banner -->
    <keep-alive>
      <v-dialog v-model="alertBannerDialog" width="500">
        <v-card>
          <v-card-title class="headline" primary-title>Alert Banner</v-card-title>
          <v-tabs v-model="tabAlert" background-color="transparent" grow>
            <v-tab v-for="item in ['Deutsch','Français','Italiano']" :key="item">{{ item }}</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabAlert">
            <v-tab-item>
              <v-card-text>
                <v-text-field label="Label" v-model="alert.de.label"></v-text-field>
                <v-text-field label="Title" v-model="alert.de.title"></v-text-field>
                <v-textarea label="Text" v-model="alert.de.text"></v-textarea>
                <v-checkbox label="Visible" v-model="alert.de.active" auto-grow rows="2"></v-checkbox>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-text-field label="Label" v-model="alert.fr.label"></v-text-field>
                <v-text-field label="Title" v-model="alert.fr.title"></v-text-field>
                <v-textarea label="Text" v-model="alert.fr.text"></v-textarea>
                <v-checkbox label="Visible" v-model="alert.fr.active" auto-grow rows="2"></v-checkbox>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-text-field label="Label" v-model="alert.it.label"></v-text-field>
                <v-text-field label="Title" v-model="alert.it.title"></v-text-field>
                <v-textarea label="Text" v-model="alert.it.text"></v-textarea>
                <v-checkbox label="Visible" v-model="alert.it.active" auto-grow rows="2"></v-checkbox>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>

          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="alertBannerDialog=false">Cancel</v-btn>
            <v-btn :loading="loading" color="success" text @click="updateAlert">Publish</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </keep-alive>
  </v-app>
</template>

<script>
import {
  UNPUBLISHED,
  PUBLISHED_WITH_CHANGES,
  PUBLISHED,
  DELETED
} from "../types";
import axios from "axios";
import uniqid from "uniqid";
export default {
  name: "App",
  data: () => ({
    tabAlert: null,
    alert: {
      id: "alert",
      it: { title: "", label: "", text: "", active: true },
      de: { title: "", label: "", text: "", active: true },
      fr: { title: "", label: "", text: "", active: true },
      counter: 0
    },
    loadingAlert: false,
    drawer: false,
    newArticleDialog: false,
    alertBannerDialog: false,
    newArticleTitle: "",
    newArticleURL: "",
    tabtitles: ["New article", "New from URL"],
    tab: null,
    loading: false
  }),
  created() {
    this.$vuetify.theme.dark = true;
  },
  computed: {
    alertState: function() {
      return this.$store.state.settings.settings.alert;
    },
    formStatus: function() {
      return (
        (this.tab === 0 && this.newArticleTitle === "") ||
        (this.tab === 1 && this.newArticleURL === "")
      );
    }
  },
  watch: {
    alertState: function(val) {
      Object.assign(this.alert, val);
    }
  },
  methods: {
    updateAlert: function() {
      this.loadingAlert = true;
      this.alert.counter += 1;
      this.$store.dispatch("settings/set", this.alert).then(() => {
        this.alertBannerDialog = false;
        this.loadingAlert = false;
      });
    },
    logout: function() {
      this.$store.dispatch("logout");
    },
    newArticle: function() {
      this.loading = true;
      console.log(this.tab);

      if (this.tab === 1) {
        this.getContentFromArticleURL(this.newArticleURL);
      } else {
        let forl = [
          this.$store.dispatch("upsertArticle", {
            title: this.newArticleTitle,
            isCompact: false,
            lang: "de",
            state: UNPUBLISHED,
            shortid: "D" + this.$store.state.settings.settings.shortids.val,
            changes: {}
          }),
          this.$store.dispatch("upsertArticle", {
            title: this.newArticleTitle,
            isCompact: false,
            lang: "fr",
            state: UNPUBLISHED,
            shortid: "F" + this.$store.state.settings.settings.shortids.val,
            changes: {}
          }),
          this.$store.dispatch("upsertArticle", {
            title: this.newArticleTitle,
            isCompact: false,
            lang: "it",
            state: UNPUBLISHED,
            shortid: "I" + this.$store.state.settings.settings.shortids.val,
            changes: {}
          })
        ];
        Promise.all(forl).then(id => {
          this.newArticleDialog = false;
          this.loading = false;
          this.$store.dispatch("settings/set", {
            shortids: {
              val: this.$store.state.settings.settings.shortids.val + 1
            }
          });
          //this.$router.push({ name: "Article", params: { id, new: true } });
        });
      }
    },
    getContentFromArticleURL: function(url) {
      axios
        .get(
          `https://cuminaivel-getarticle.herokuapp.com/getarticle?url=${this.newArticleURL}`
        )
        .then(res => {
          let newart = {};
          Object.assign(newart, res.data);
          newart.picture = newart.imageSrc;
          delete newart.imageSrc;
          delete newart.text;
          newart.state = UNPUBLISHED;
          newart.homeType = "pictureFromURL";
          newart.isCompact = false;
          newart.blocks = [];
          newart.changes = {};
          var newBlock = {
            type: "text",
            content: res.data.text
          };
          newart.blocks.push(newBlock);
          newart.shortid =
            newart.lang.toUpperCase().charAt(0) +
            this.$store.state.settings.settings.shortids.val;
          newart.pubTime = new Date()
            .toLocaleTimeString()
            .split(":")
            .slice(0, 2)
            .join(":");

          let l1 = newart.lang === "de" ? "fr" : newart === "fr" ? "de" : "fr";
          let l2 = newart.lang === "de" ? "it" : newart === "fr" ? "it" : "de";

          return Promise.all([
            this.$store.dispatch("upsertArticle", newart),
            this.$store.dispatch("upsertArticle", {
              title: this.newArticleTitle,
              isCompact: false,
              lang: l1,
              state: UNPUBLISHED,
              shortid:
                l1.toUpperCase().charAt(0) +
                this.$store.state.settings.settings.shortids.val,
              changes: {}
            }),
            this.$store.dispatch("upsertArticle", {
              title: this.newArticleTitle,
              isCompact: false,
              lang: l2,
              state: UNPUBLISHED,
              shortid:
                l2.toUpperCase().charAt(0) +
                this.$store.state.settings.settings.shortids.val,
              changes: {}
            })
          ]);
        })
        .then(() => {
          this.newArticleDialog = false;
          this.loading = false;
          this.$store.dispatch("settings/set", {
            shortids: {
              val: this.$store.state.settings.settings.shortids.val + 1
            }
          });
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
          this.newArticleDialog = false;
        });
    }
  }
};
</script>
<style lang="scss">
.fab-container {
  position: absolute;
  top: 2em;
  right: 1em;
}
</style>